import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deactivateWorker, reactivateWorker } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";

export interface SetWorkerActiveInput {
	workerId: string;
	active: boolean;
}

export function useSetWorkerActive() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (input: SetWorkerActiveInput) =>
			input.active
				? reactivateWorker(activeCanteiroId as string, input.workerId)
				: deactivateWorker(activeCanteiroId as string, input.workerId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["workers"] });
			queryClient.invalidateQueries({ queryKey: ["time-entries"] });
			queryClient.invalidateQueries({ queryKey: ["attendance"] });
		},
	});
}
